// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const useHandleShouldLoadCart = () => {
    const dispatch = useDispatch();
    const shouldLoadCart = useShouldLoadCart();

    useEffect(() => {
        if (shouldLoadCart) {
            dispatch(loadCurrentCart({ shouldLoadFullCart: false, replaceCart: false }));
        }
    }, [shouldLoadCart]);
};

export const useShouldLoadCart = () => {
    return useAppSelector(state => !getCurrentCartState(state).value && !getCurrentCartState(state).isLoading);
};
